import { render, staticRenderFns } from "./stock_metric_chart.vue?vue&type=template&id=0dd410a2&"
import script from "./stock_metric_chart.vue?vue&type=script&lang=js&"
export * from "./stock_metric_chart.vue?vue&type=script&lang=js&"
import style0 from "./stock_metric_chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports